// extracted by mini-css-extract-plugin
export default {"wrapper":"LB-z","response":"MB-z","error":"NB-z","disabled":"OB-z","buttons":"PB-z","feedbackQuestionSection":"QB-z","yesNoWrapper":"RB-z"};